import { Component, OnDestroy, OnInit } from '@angular/core';
import { CiamFlagsService } from '@core/services/ciam-flags.service';
import { JitMigrationService, ModalService } from '@core/services';
import { NUDGE_TRIGGER } from '@core/services/migration-nudge-state.service';

@Component({
  selector: 'app-migration-nudge-prompt',
  templateUrl: './migration-nudge-prompt.component.html',
  styleUrls: ['./migration-nudge-prompt.component.less']
})
export class MigrationNudgePromptComponent implements OnInit, OnDestroy {
  title = '';
  body = '';
  primaryCta = '';
  secondaryCta = '';
  bonusPoints = 0;
  readonly isMandatory: boolean;

  private dismissalHandled = false;

  constructor(
    private ciamFlagsService: CiamFlagsService,
    private jitMigrationService: JitMigrationService,
    private modalService: ModalService
  ) {
    //read here rather than in ngOnInit: the modal shell inspects isBlockingModal as soon as it creates
    //this component, which happens before the first change detection pass runs ngOnInit
    this.isMandatory = this.jitMigrationService.getLastDecision()?.isMandatory ?? false;
  }

  /** Consumed by ModalComponent to hide the close control and disable Escape. */
  get isBlockingModal(): boolean {
    return this.isMandatory;
  }

  ngOnInit(): void {
    const config = this.ciamFlagsService.getNudgeConfig();
    this.title = this.isMandatory ? config.mandatoryTitle : config.title;
    this.body = this.isMandatory ? config.mandatoryBody : config.body;
    this.primaryCta = this.isMandatory ? config.mandatoryCta : config.primaryCta;
    this.secondaryCta = config.secondaryCta;
    //zeroing this also hides the bonus points line, which has no place on a nudge the user cannot decline
    this.bonusPoints = this.isMandatory ? 0 : config.bonusPoints;
  }

  ngOnDestroy(): void {
    if (this.dismissalHandled) {
      return;
    }
    //the close control and Escape both go through the modal shell without touching this component, so
    //without this those dismissals were never counted and the ladder never advanced for those users
    this.jitMigrationService.recordPromptDismissed(NUDGE_TRIGGER.modalClose);
  }

  onSwitchNow(): void {
    //the OTP flow owns the outcome from here, including recording abandonment
    this.dismissalHandled = true;
    this.modalService.hideModal();
    this.jitMigrationService.openOtpFlowModal();
  }

  onNotYet(): void {
    this.dismissalHandled = true;
    this.jitMigrationService.recordPromptDismissed(NUDGE_TRIGGER.secondaryCta);
    this.modalService.hideModal();
  }
}
